<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates25">
<p class="centerImage"><img alt="images" id="plate25" src="images/plate25.jpg"/></p>
<p class="caption">One of our new Spitfires arrives at Richmond and the ground crews get busy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates25.vue?92768d7e